import { render, staticRenderFns } from "./CasePremiumEdit.vue?vue&type=template&id=23c2d102&scoped=true"
import script from "./CasePremiumEdit.vue?vue&type=script&lang=js"
export * from "./CasePremiumEdit.vue?vue&type=script&lang=js"
import style0 from "./CasePremiumEdit.vue?vue&type=style&index=0&id=23c2d102&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c2d102",
  null
  
)

export default component.exports